module.exports = __webpack_public_path__ + "ui-static/img/not-found-alien_dark.1e044493.svg";